exports.minutesToDate = function (totalMinutes) {
  if (!totalMinutes) return null;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  return date;
};

exports.momentToMinutes = function (date) {
  if (!date) return null;
  const hh = date.get("hours");
  const mm = date.get("minutes");

  return hh * 60 + mm;
};

exports.dateToMinutes = function (date) {
  if (!date) return null;

  const hh = date.getHours();
  const mm = date.getMinutes();

  return hh * 60 + mm;
};



//////////////////
// WEBPACK FOOTER
// ./functions/common/dateUtils.js
// module id = 627
// module chunks = 0